import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fComp } from '../../utils/React.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import '../IconLinkGroup/IconLinkGroupPresentation.js';
import './Headline.styles.js';

var defaultProps = {
  size: "h1",
  variant: ""
};
var HeadlinePresentation = fComp(function (_ref) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3, _cleanupClassObject4;

  var as = _ref.as,
      children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      noMargin = _ref.noMargin,
      overline = _ref.overline,
      overlineAs = _ref.overlineAs,
      subline = _ref.subline,
      sublineAs = _ref.sublineAs,
      size = _ref.size,
      variant = _ref.variant,
      centeredLayout = _ref.centeredLayout,
      horizontalAlignment = _ref.horizontalAlignment,
      htmlAttrs = _ref.htmlAttrs,
      actions = _ref.actions;
  var HeadlineComponent = as || size;
  var OverlineComponent = overlineAs || "div";
  var SublineComponent = sublineAs || "div";
  var align = centeredLayout ? "center" : horizontalAlignment;
  var overlineSize = {
    h1: "large",
    h2: "large",
    h3: "large",
    h4: "small",
    h5: "small",
    h6: "small"
  }[size] || "small";
  var headlineGroup = /*#__PURE__*/React.createElement(React.Fragment, null, overline &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(OverlineComponent, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(lsgPre, "overline-").concat(overlineSize), true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "overline__align-").concat(align), align), _cleanupClassObject))
  }, overline), /*#__PURE__*/React.createElement(HeadlineComponent, Object.assign({}, htmlAttrs, {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(lsgPre).concat(size).concat(variant && "-".concat(variant)), true), _defineProperty(_cleanupClassObject2, "".concat(className), !!className), _defineProperty(_cleanupClassObject2, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject2, "".concat(lsgPre, "headline__align-").concat(align), align), _cleanupClassObject2)),
    id: id
  }), children), subline &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(SublineComponent, {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(lsgPre, "subline"), true), _defineProperty(_cleanupClassObject3, "".concat(lsgPre, "subline__align-").concat(align), align), _cleanupClassObject3))
  }, subline));
  return /*#__PURE__*/React.createElement(React.Fragment, null, actions && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject4 = {}, _defineProperty(_cleanupClassObject4, "".concat(lsgPre, "headline-action-group"), true), _defineProperty(_cleanupClassObject4, "".concat(lsgPre).concat(size, "-action-group"), true), _defineProperty(_cleanupClassObject4, "".concat(lsgPre, "headline-overline-action-group"), overline), _cleanupClassObject4))
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "action-group-headline-area"), true))
  }, headlineGroup), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "action-group-action-area"), true))
  }, /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
    direction: "horizontal",
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "no-margin"), true))
  }, actions))), !actions && /*#__PURE__*/React.createElement(React.Fragment, null, headlineGroup));
}, defaultProps);

export { HeadlinePresentation };
